// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PutProductDetailsChangeMainProductBody, BaseResponseVoid } from '../../types';

/**
 * changeMainProduct
 *
 * @export
 * @tags product-detail-controller
 * @link [PUT] /productDetails/changeMainProduct
 */
export function putProductDetailsChangeMainProduct(
    data: PutProductDetailsChangeMainProductBody
): Promise<BaseResponseVoid>;
export function putProductDetailsChangeMainProduct(
    data: PutProductDetailsChangeMainProductBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function putProductDetailsChangeMainProduct(
    data: PutProductDetailsChangeMainProductBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PutProductDetailsChangeMainProductBody, never, never>(
        '/productDetails/changeMainProduct',
        {
            ...options,
            data,
            method: 'put',
            __$requestCalleeName: 'putProductDetailsChangeMainProduct',
        }
    );
}

export const meta = [
    {
        tags: ['product-detail-controller'],
        path: '/productDetails/changeMainProduct',
        method: 'put',
    },
];
